export default __webpack_public_path__ + "static/media/avatarofmitra.7239764c.png";